import LoadBar from './LoadBar'
export default LoadBar
